export { default } from './SearchHeader';
